module.exports = __webpack_public_path__ + "img/hk_feature5.7f21d787.jpg";